import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function SuccessPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0fdf4 0%, #eff6ff 100%)',
      padding: 24,
    }}>
      <div className="card" style={{ maxWidth: 400, width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>✅</div>
        <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 12, color: '#166534' }}>
          Карта подписана!
        </h1>
        <p style={{ color: '#6b7280', fontSize: 15, lineHeight: 1.6, marginBottom: 24 }}>
          Регистрационная карта успешно подписана и сохранена.
          Приятного пребывания!
        </p>
        <div style={{
          background: '#f0fdf4',
          border: '1px solid #bbf7d0',
          borderRadius: 8,
          padding: '12px 16px',
          fontSize: 14,
          color: '#166534',
          marginBottom: 24,
        }}>
          🏨 Добро пожаловать в наш отель
        </div>
        <button
          className="btn btn-primary w-full"
          style={{ fontSize: 16, padding: 14 }}
          onClick={() => navigate('/admin')}
        >
          На главную
        </button>
      </div>
    </div>
  );
}
